import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type TabItem<V extends string = string> = {
  value: V;
  label: string;
  count?: number;
  icon?: ReactNode;
};

export function Tabs<V extends string>({
  items,
  value,
  onChange,
}: {
  items: TabItem<V>[];
  value: V;
  onChange: (v: V) => void;
}) {
  return (
    <div className="flex gap-1 border-b border-slate-200">
      {items.map((it) => {
        const active = it.value === value;
        return (
          <button
            key={it.value}
            onClick={() => onChange(it.value)}
            className={cn(
              "flex items-center gap-2 border-b-2 px-4 py-2 text-sm font-medium transition-colors",
              active
                ? "border-moving-500 text-slate-900"
                : "border-transparent text-slate-500 hover:text-slate-700",
            )}
          >
            {it.icon ? <span>{it.icon}</span> : null}
            {it.label}
            {typeof it.count === "number" ? (
              <span
                className={cn(
                  "rounded-md px-1.5 py-0.5 text-xs font-medium",
                  active
                    ? "bg-moving-100 text-moving-700"
                    : "bg-slate-100 text-slate-600",
                )}
              >
                {it.count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
